<template>
  <div class="text-textColor absolute">
    <transition name="fade">
      <div
        v-if="showSearch"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full"
      >
        <div
          class="fixed mx-auto inset-x-0 top-20 bg-white rounded-md shadow-2xl sm:w-1/3 w-full"
        >
          <div class="flex justify-between items-center p-3">
            <p class="text-sm font-medium">What do you want to find</p>
            <img
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close"
            />
          </div>
          <form @submit.prevent="search" class="p-3">
            <input
              ref="search"
              autofocus
              type="search"
              required
              v-model="query"
              placeholder="Search..."
              class="p-1 border-1.5 bg-gray-100 w-full rounded focus:ring-1 focus:ring-primary focus:bg-white"
            />
            <div class="flex flex-col mt-2">
              <div
                class="cursor-pointer hover:bg-gray-200 rounded-md p-2 text-sm"
                @click="openLink(menu.item)"
                v-for="menu in results"
                :key="menu.route"
              >
                <p class="font-semibold">{{ menu.item.name }}</p>
                <p>{{ menu.item.about }}</p>
              </div>
            </div>
            <button type="submit" class="hidden"></button>
          </form>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Fuse from "fuse.js";
export default {
  name: "Search",
  props: ["showSearch"],
  data() {
    return {
      results: null,
      query: null,
    };
  },
  watch: {
    query: function (value) {
      if (value.length > 0) {
        this.search();
      } else if (value.length == 0) {
        this.results = null;
      }
    },
  },
  computed: {
    ...mapGetters(["getFilteredMenu"]),
  },
  mounted() {
    const inputRef = this.$refs.search;
    inputRef?.focus();
  },
  created() {
    this.result = null;
    this.query = null;
  },
  methods: {
    search() {
      const options = {
        includeScore: true,
        minMatchCharLength: 2,
        threshold: 0.5,
        keys: ["name", "about", "keywords"],
      };
      const fuse = new Fuse(this.getFilteredMenu, options);
      this.results = fuse.search(this.query);
    },
    close() {
      this.$emit("close");
      this.result = null;
      this.query = null;
    },
    openLink(result) {
      this.close();
      this.query = null;
      this.results = null;
      this.$router.push({
        name: result.route,
        params: { company: this.getOrganization },
      });
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.toppest {
  z-index: 9999;
}
</style>
